import { ActivationStatus } from "@humanex/interfaces";
import { cn } from "@humanex/ui/libs";
import { Outlet, createFileRoute, useMatchRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { LoadingPage } from "@/components/loading.page";
import { useActivationStatus } from "@/hooks/queries";
import { useAuthStore } from "@/stores/auth.store";

import { Sidebar } from "./-components/sidebar";
import { TopBar } from "./-components/topbar";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent
});

function RouteComponent() {
  const { loggedIn, loading } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const matchRoute = useMatchRoute();

  const activationQuery = useActivationStatus({ enabled: loggedIn });
  const isActive = activationQuery.data?.status === ActivationStatus.ACTIVE;

  useEffect(() => {
    if (loading || activationQuery.isLoading) return;
    else if (!loggedIn) navigate({ to: "/" });
    else if (!isActive) navigate({ to: "/activate" });
    else if (matchRoute({ to: "/" })) navigate({ to: "/home" });
  }, [loading, loggedIn, isActive, activationQuery.isLoading, navigate]);

  if (loading || activationQuery.isLoading) {
    return <LoadingPage />;
  }

  if (matchRoute({ to: "/activate" })) {
    return <Outlet />;
  }

  return (
    <div
      className={cn(
        "flex h-screen w-full overflow-hidden bg-primary-50",
        "p-2 sm:p-3 md:p-4 gap-2 sm:gap-3 md:gap-4 max-w-[2200px] mx-auto"
      )}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-col flex-1 overflow-hidden">
        <TopBar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto pt-0 pb-6 scrollbar-none">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
